module.exports = __webpack_public_path__ + "img/search.bf4c4c63.png";